import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthenticatedRoute from './AuthenticatedRoute';
import ProtectedLoginRoute from './ProtectedLoginRoute';
import Login from '../pages/Login';
import LoginPhoneSet from '../pages/login/LoginPhoneSet';
import LoginPhoneVerify from '../pages/login/LoginPhoneVerify';
import LoginUpdatePhone from '../pages/login/LoginUpdatePhone';
import Register from '../pages/Register';
import ConfirmEmail from '../pages/register/ConfirmEmail';
import ConfirmKyc from '../pages/register/ConfirmKyc';

import EmailVerify from '../pages/forgotPassword/EmailVerify';
import PasswordReset from '../pages/forgotPassword/PasswordReset';
import ForgotPasswordSuccess from '../pages/forgotPassword/ForgotPasswordSuccess';
import HomePage from '../pages/HomePage';
import Faq from '../pages/Faq';
import TermsOfServices from '../pages/TermsOfServices';
import Policy from '../pages/Policy';
import Dashboard from '../pages/Dashboard';
import Account from '../pages/Account';
import History from '../pages/History';
import Rewards from '../pages/Rewards';
import Recharge from '../pages/Recharge';
import Transfer from '../pages/Transfer';
import Contact from '../pages/Contact';
import Layout from '../layouts/Layout';
import Assets from '../pages/Assets';
import SendToUser from '../pages/SendToUser';
import Investments from '../pages/Investments';
import Glossary from '../pages/Glossary';
import Statements from '../pages/Statements';
import Statement from '../pages/Statement';
import Goals from '../pages/Goals';
import GoalNew from '../pages/GoalNew';
import GoalDetail from '../pages/GoalDetail';
import Business from '../pages/Business';
import BusinessLayout from '../layouts/BusinessLayout';
import BusinessHome from '../pages/business/BusinessHome';
import BusinessSoon from '../pages/business/BusinessSoon';
import BusinessEquipo from '../pages/business/BusinessEquipo';
import BusinessTesoreria from '../pages/business/BusinessTesoreria';
import BusinessProvisiones from '../pages/business/BusinessProvisiones';
import BusinessRendimientos from '../pages/business/BusinessRendimientos';
import { BusinessExtractosList, BusinessExtractosDetail } from '../pages/business/BusinessExtractosOla';
import BusinessCaja from '../pages/business/BusinessCaja';
import BusinessCartera from '../pages/business/BusinessCartera';
import BusinessCalendario from '../pages/business/BusinessCalendario';
import BusinessBlockchain from '../pages/business/BusinessBlockchain';
import BusinessContratistas from '../pages/business/BusinessContratistas';
import CobrarEnDolares from '../pages/CobrarEnDolares';
import BusinessHistorial from '../pages/business/BusinessHistorial';
import PagarCobro from '../pages/PagarCobro';
import GoalDiagnostic from '../pages/GoalDiagnostic';
import Capsulas from '../pages/Capsulas';
import Agentes from '../pages/Agentes';
import MiMapa from '../pages/MiMapa';

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login" element={<ProtectedLoginRoute />}>
          <Route path="phoneSet" element={<LoginPhoneSet />} />
          <Route path="phoneVerify" element={<LoginPhoneVerify />} />
          <Route path="updatePhone" element={<LoginUpdatePhone />} />
        </Route>

        <Route path="/register">
          <Route index element={<Register />} />
          <Route path="confirm-email/:email" element={<ConfirmEmail />} />
          <Route path="confirm-kyc/:id" element={<ConfirmKyc />} />
        </Route>

        <Route path="/forgotPassword">
          <Route index element={<EmailVerify />} />
          <Route path="reset" element={<PasswordReset />} />
          <Route path="success" element={<ForgotPasswordSuccess />} />
        </Route>

        <Route path="/" element={<HomePage />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/termsOfServices" element={<TermsOfServices />} />
        <Route path="/policy" element={<Policy />} />

        <Route
          path="/dashboard"
          element={
            <AuthenticatedRoute>
              <Layout />
            </AuthenticatedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="accounts" element={<Account />} />
          <Route path="history" element={<History />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="recharge" element={<Recharge />} />
          <Route path="transfer" element={<Transfer />} />
          <Route path="contact" element={<Contact />} />
          <Route path="assets" element={<Assets />} />
          <Route path="send" element={<SendToUser />} />
          <Route path="investments" element={<Investments />} />
          <Route path="agentes" element={<Agentes />} />
          <Route path="glosario" element={<Glossary />} />
          <Route path="statements" element={<div className="extractos-pers-ola"><Statements /></div>} />
          <Route path="statements/:period" element={<div className="extractos-pers-ola"><Statement /></div>} />
          <Route path="capsulas" element={<Capsulas />} />
          <Route path="mapa" element={<MiMapa />} />
          <Route path="metas" element={<Goals />} />
          <Route path="metas/diagnostico" element={<GoalDiagnostic />} />
          <Route path="metas/nueva" element={<GoalNew />} />
          <Route path="metas/:id" element={<GoalDetail />} />
        </Route>

        {/* PUBLICO: la pagina del link de cobro — el pagador NO necesita FlowexPay */}
        <Route path="/pagar/:linkId" element={<PagarCobro />} />
        {/* PUBLICO: el contratista registra SU direccion — la empresa no puede escribirla */}
        <Route path="/cobrar-en-dolares/:token" element={<CobrarEnDolares />} />

        {/* FlowexPay Business — dashboard EMPRESARIAL (piloto whitelist).
            Separado del dashboard de personas; futuro business.flowexpay.com */}
        <Route
          path="/business"
          element={
            <AuthenticatedRoute>
              <BusinessLayout />
            </AuthenticatedRoute>
          }
        >
          <Route index element={<BusinessHome />} />
          {/* La nomina anterior capturaba y aprobaba pero NUNCA disperso: su codigo de
              pago era un comentario. /pagos usa el motor nuevo; el viejo queda de historico. */}
          <Route path="pagos" element={<BusinessContratistas />} />
          <Route path="pagos-anterior" element={<Business />} />
          <Route path="tesoreria" element={<BusinessTesoreria />} />
          <Route path="provisiones" element={<BusinessProvisiones />} />
          <Route path="rendimientos" element={<BusinessRendimientos />} />
          <Route path="apartados" element={<BusinessProvisiones />} />
          {/* alias: la ruta vieja no se rompe si alguien la guardo */}
          <Route path="sobres" element={<BusinessProvisiones />} />
          <Route path="caja" element={<BusinessCaja />} />
          <Route path="cartera" element={<BusinessCartera />} />
          <Route path="calendario" element={<BusinessCalendario />} />
          <Route path="blockchain" element={<BusinessBlockchain />} />
          <Route path="contratistas" element={<BusinessContratistas />} />  {/* alias */}
          {/* Transaccional de la empresa: mismas paginas de personas, montadas
              DENTRO del layout Business para no sacar al usuario de su mundo */}
          <Route path="recargar" element={<Recharge />} />
          <Route path="enviar" element={<Transfer />} />
          <Route path="historial" element={<BusinessHistorial />} />
          <Route path="cuentas-globales" element={<Account />} />
          <Route path="equipo" element={<BusinessEquipo />} />
          <Route path="extractos" element={<BusinessExtractosList />} />
          <Route path="extractos/:period" element={<BusinessExtractosDetail />} />
          <Route path="integraciones" element={<BusinessSoon section="integraciones" />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
